import React, { useState,useEffect,useRef } from 'react'
import { MDBContainer, MDBRow, MDBCol,MDBInput, MDBBtn
    ,MDBFileInput  } from 'mdbreact';

import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBCardFooter  } from "mdbreact";

import "../css/scrollbar.css";
    
import Axios from 'axios';
    

    
import "react-datepicker/dist/react-datepicker.css";

import PhotoUpload from "../components/PhotoUpload";

    
 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import WarningBox from '../components/WarningBox';




const ChangeProfilePhoto=(props)=> {
    const useMountEffect = (functionName) => useEffect(functionName, [])
  
    const serverURL=props.apiServer;
    const [profilephoto,setProfilePhoto]=useState('default.jpg');

 const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }

  const scrollContainerStyle = { width: "100%", minHeight: "680px" };
  const [frm, setValues] = useState({
    code: props.code
    ,username: sessionStorage.getItem("msal.uc")
    ,originalfilename:''
    ,uploadedfile:''
    ,contenttype:'application/pdf'
    ,restricted:false
   

   
   

  });
  





	


  const [errorMessage,setErrorMessage]=useState("");

  

const notify = message  => {
    toast(message);
}

const [modalWarning,showWarningBox]=useState(false);
  

  
const toggleWarningBox = () => {
  showWarningBox(!modalWarning);

  }



const updateField = e => {
       
  const target=e.target;
 
  let  value =target.value;
  let name=target.id;

  if(target.type==="checkbox")
  {
    value=target.checked;

    setValues({ ...frm, [name]: value });
  }
  else
  {
    setValues({ ...frm, [name]: value });
  }

 

};
  


  const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });
   
 };

 
    
 function getprofilepic() {
      
  
    Axios.get(props.apiServer + "/getprofilepic?token=" + sessionStorage.getItem("msal.uc"),bearer)
     .then(res => {
     
     
        setProfilePhoto(res.data[0].filename);
        setPreloader("none");
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }
   
useMountEffect(getprofilepic);


/* eslint-disable */


    return (
       <React.Fragment>
  
   <form
                    className="needs-validation"
                    // onSubmit={submitHandler}
                    noValidate
                    >
 
                     
                

                
                   <MDBRow hidden >
                       <MDBCol md="12">

                       <MDBInput  
                            hidden
                            value={frm.code} 
                            id="code"  
                            label="Code" 
                            >
                                <div className="invalid-feedback">
                                This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                       </MDBCol>

                       
                      
                   </MDBRow>

                   <MDBRow hidden >
                       <MDBCol md="12">

                       <MDBInput  
                            hidden
                            value={frm.username} 
                            id="username"  
                            label="username" 
                            >
                                <div className="invalid-feedback">
                                This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                       </MDBCol>

                       
                      
                   </MDBRow>
                   <MDBRow hidden>
                        <MDBCol md="6">
                            <MDBInput  
                                hidden
                                value={frm.employeecode} 
                                id="employeecode"  
                                label="Directive Code" 
                                onChange={updateField}>
                                
                                    <div className="invalid-feedback">
                                    This field is required!
                                </div>
                                <div className="valid-feedback"></div>

                            </MDBInput>
                        </MDBCol>

                       

                   </MDBRow>

            
                   

                   <MDBRow>
                        <MDBCol md="12" className="text-left">
                           
                        
                          <img  src={props.apiServerHybrid + "/profilephoto/" + profilephoto} width="300px" className="img-fluid z-depth-1-half rounded-circle"
              alt="" />
              
                        </MDBCol>


                   </MDBRow>
                <MDBRow>
                        <MDBCol md="12" className="text-left">
                           
                            <PhotoUpload 
                            apiServer={props.apiServer} 
                             username={sessionStorage.getItem("msal.uc")} 
                             toggleModal={props.toggleModal}
                             getprofilepic={getprofilepic}
                             />
                            <br/>
                        </MDBCol>


                   </MDBRow>

                 
                  

                  
                 

                 
                  


              
                 
                   
                  
                   

                  
                 
                
                   

    
   
  

  <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />


  </form>

  

                <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
              
                </React.Fragment>    
    )
}

export default ChangeProfilePhoto
